import axios from "axios";
import {notify} from "@kyvg/vue3-notification";

export default {
    namespaced: true,

    state: () => ({
        showForm: false,
    }),

    mutations: {
        showForm(state) {
            state.showForm = true;
        },
        hideForm(state) {
            state.showForm = false;
        }
    },

    actions: {
        async sendForm({ commit }, data) {
            await axios.post(`/feedback`, data);
        },
    }
}
